var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1097_8200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.31995 3.45455L7.9118 1.82872C8.28671 0.79799 9.39961 0 10.4552 0H17.5448C18.6055 0 19.7105 0.796178 20.0867 1.82854L20.6786 3.45455H25.8979C27.0564 3.45455 28 4.43086 28 5.62909V21.3891C28 22.5894 27.0545 23.5636 25.8979 23.5636H2.1021C0.943981 23.5636 0 22.5863 0 21.3891V5.62909C0 4.42882 0.945544 3.45455 2.1021 3.45455H7.31995ZM2.1021 4.90909C1.71616 4.90909 1.4 5.23485 1.4 5.62909V21.3891C1.4 21.7818 1.7161 22.1091 2.1021 22.1091H25.8979C26.2838 22.1091 26.6 21.7833 26.6 21.3891V5.62909C26.6 5.23553 26.2845 4.90909 25.8979 4.90909H19.7114L19.5403 4.43909L18.7774 2.34335C18.6069 1.87565 18.0225 1.45455 17.5448 1.45455H10.4552C9.98152 1.45455 9.39035 1.87844 9.22134 2.34309L8.28725 4.90909H2.1021ZM2.8 1.45455H4.9C5.2866 1.45455 5.6 1.78016 5.6 2.18182C5.6 2.58348 5.2866 2.90909 4.9 2.90909H2.8C2.4134 2.90909 2.1 2.58348 2.1 2.18182C2.1 1.78016 2.4134 1.45455 2.8 1.45455ZM14 19.6364C10.5206 19.6364 7.7 16.7059 7.7 13.0909C7.7 9.47595 10.5206 6.54545 14 6.54545C17.4794 6.54545 20.3 9.47595 20.3 13.0909C20.3 16.7059 17.4794 19.6364 14 19.6364ZM14.7 12.3636V10.1782C14.7 9.78545 14.3864 9.45455 14 9.45455C13.6108 9.45455 13.3 9.77891 13.3 10.1782V12.3636H11.1965C10.8185 12.3636 10.5 12.6895 10.5 13.0909C10.5 13.4953 10.8122 13.8182 11.1965 13.8182H13.3V16.0036C13.3 16.3964 13.6136 16.7273 14 16.7273C14.3892 16.7273 14.7 16.4029 14.7 16.0036V13.8182H16.8035C17.1815 13.8182 17.5 13.4924 17.5 13.0909C17.5 12.6865 17.1878 12.3636 16.8035 12.3636H14.7Z",
    fill: "#A1A5B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1097_8200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.a4fc7614.svg";
export { ForwardRef as ReactComponent };